export const storageAdd = {
	warningProductAlreadyOnList: "Esse produto já foi adicionado na lista!",
	title: "Adicionar produto no estoque {{storageName}}",
	cancel: "Cancelar",
	finish: "Concluido",
	addProductForm: {
		form: {
			modalWarning: {
				title: "Produto com custo zerado",
				errorMessage:
					"O custo unitário zerado impactará no acompanhamento do seu CMV e prejudicará a leitura de alguns relatórios financeiros. Deseja continuar mesmo assim?",
				button: "Não, preencher o custo",
			},
			label: {
				product: "Produto",
				count: "Quantidade",
				cost: "Preço de custo",
			},
			validation: {
				missingField: "Campo obrigatorio",
				invalidQuantity: "Quantidade invalida",
			},
			submit: "Adicionar",
		},
	},
	table: {
		columns: {
			product: "Produto",
			count: "Quantidade",
			unitcost: "Custo unitário",
			totalcost: "Custo total",
			action: "ação",
		},
	},
};
